import script from './index.vue_vue_type_script_lang.mjs';
export { default } from './index.vue_vue_type_script_lang.mjs';

script.__file = "packages/components/popper/src/index.vue";
//# sourceMappingURL=index.mjs.map
